import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import AttachmentModal from './AttachmentModal';
import { MdAttachFile } from 'react-icons/md';

const AttachmentViewer = ({ attachmentList, challengeId, quizNo }) => {
    const { t } = useTranslation();
    const [showModal, setShowModal] = useState(false);

    // 첨부파일 목록 파싱 및 개수 확인
    const getAttachmentCount = () => {
        if (!attachmentList) return 0;
        try {
            const attachments = typeof attachmentList === 'string'
                ? JSON.parse(attachmentList)
                : attachmentList;
            return Array.isArray(attachments) ? attachments.length : 0;
        } catch (error) {
            console.error('첨부파일 목록 파싱 오류:', error);
            return 0;
        }
    };

    const count = getAttachmentCount();

    // 첨부파일이 없으면 아무것도 렌더링하지 않음
    if (count === 0) {
        return null;
    }

    return (
        <>
            <button
                onClick={() => setShowModal(true)}
                style={{
                    background: 'transparent',
                    color: '#6c757d',
                    border: 'none',
                    padding: 0,
                    cursor: 'pointer',
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 4,
                    verticalAlign: 'middle'
                }}
                onMouseEnter={(e) => e.currentTarget.style.color = '#495057'}
                onMouseLeave={(e) => e.currentTarget.style.color = '#6c757d'}
                title={t('common:att.viewExtras')}
            >
                <MdAttachFile size={16} />
                <span style={{ fontSize: 11 }}>{t('common:att.extrasCount', { n: count })}</span>
            </button>

            {showModal && (
                <AttachmentModal
                    attachmentList={attachmentList}
                    challengeId={challengeId}
                    quizNo={quizNo}
                    onClose={() => setShowModal(false)}
                />
            )}
        </>
    );
};

export default AttachmentViewer;
